import { render, staticRenderFns } from "./drawRecords.vue?vue&type=template&id=337f8b9a&scoped=true&"
import script from "./drawRecords.vue?vue&type=script&lang=js&"
export * from "./drawRecords.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "337f8b9a",
  null
  
)

export default component.exports